const icons = new Map();
icons.set('DARK', 'moonStars');
icons.set('LIGHT', 'sunBright');
icons.set('SYSTEM', 'display');

const scheme = (handle) => icons.get(handle);

export default scheme;
